import { useContext } from 'react';
import { Dropdown, Menu, Space } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { useLanguage } from '../../../../infrastructure/hooks/useLanguage';
import { UserDataContext } from '../../../contexts/Contexts';

const languageLabels = { en: 'English', es: 'Español' };

const LanguageSelectNavBar = () => {
  const { lang, changeLanguage, loading } = useLanguage();
  const { userData } = useContext(UserDataContext);

  const currentLang = (lang ?? userData?.idioma ?? 'en').toLowerCase();

  const handleMenuClick = async ({ key }) => {
    if (key !== currentLang) {
      await changeLanguage(key, userData?.idUsuario);
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick} selectedKeys={[currentLang]}>
      <Menu.Item key="en">English</Menu.Item>
      <Menu.Item key="es">Español</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
      arrow
      overlayClassName="nb-language-dropdown"
      getPopupContainer={(triggerNode) =>
        triggerNode.closest(".vn-sidebar") || document.body
      }
    >
      <div className={`nb-language ${loading ? 'is-loading' : ''}`}>
        <Space size="small">
          <GlobalOutlined />
          <span className="nb-lang-text">{languageLabels[currentLang]}</span>
          <DownOutlined />
        </Space>
      </div>
    </Dropdown>
  );
};

export default LanguageSelectNavBar;
